import { inject, Injectable, signal } from '@angular/core';
import { map, Observable } from 'rxjs';

import { ReportingClient } from '../clients/reporting.client';
import { FilterCriteria, ReportingFile, TimeAggregation } from '../model/reporting.model';

@Injectable({ providedIn: 'root' })
export class ReportingService {
  readonly filter = signal<FilterCriteria>(this.defaultFilterCriteria());
  readonly reportingClient = inject(ReportingClient);

  private defaultFilterCriteria(): FilterCriteria {
    const today = new Date();
    const from = new Date(Date.UTC(today.getFullYear(), today.getMonth() - 1, 1));
    const to = new Date(Date.UTC(today.getFullYear(), today.getMonth(), 1));
    return {
      timeAggregation: TimeAggregation.MONTHLY,
      from: from,
      to: to,
      usecases: [],
      country: undefined,
    };
  }

  setFilterOptions(criteria: Partial<FilterCriteria>) {
    this.filter.update((f) => ({ ...f, ...criteria }));
  }

  getAvailableFilterOptions() {
    return this.reportingClient.getOptions();
  }

  downloadReport(): Observable<ReportingFile> {
    return this.reportingClient.getReport(this.filter()).pipe(
      map((response) => {
        const blob = response.body!;
        const disposition = response.headers.get('Content-Disposition');
        const match = disposition?.match(/filename="([^"]+)"/);
        const filename = match ? match[1] : 'cdf-report.csv.zip';
        return { file: blob, filename: filename };
      }),
    );
  }
}
